import React, { Component } from 'react';
import axios from 'axios';
import cookie from 'react-cookie';
import Modal from 'react-modal'
import {toastr} from 'react-redux-toastr';

export default class BannerCategory extends Component {
  constructor(props) {
    super(props)
    this.state = {
      fair: this.props.fair,
      access_token: cookie.load('accessToken') || '',
      API_URL: this.props.fair && this.props.fair.apiUrl || '',
      categories: [],
      item: {},
      modalIsOpen:false,
      featuredBanner: '',
      link: ''
    }
  }

  componentWillMount () {
    Modal.setAppElement('body')
  }

  componentDidMount() {
    this.getCategory();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.props.fair !== prevProps.fair) {
      this.setState({
        fair: this.props.fair || {},
        API_URL: this.props.fair && this.props.fair.apiUrl || ''
      },() => {
        this.getCategory()
      })
    }
  }

  getCategory() {
    if (this.state.API_URL) {
      axios({
        method: 'GET',
        url:`${this.state.API_URL}/categories`,
        headers: {
          Authorization: `${this.state.access_token}`
        }
      }).then(response => {
        if (response.data) {
          this.setState({
            categories: response.data.filter(item => item.parentId !== null)
          })
        }
      }).catch(error => {
        console.log(error)
      })
    }
  }

  closeModal() {
    this.setState({modalIsOpen: false, item: {}, loading: false})
  }

  showPopup(item) {
    this.setState({
      item,
      featuredBanner: item.featuredBanner || '',
      link: item && item.accompanyingInfo ? item.accompanyingInfo.link : '',
      modalIsOpen: true
    })
  }

  onRemoveImage() {
    this.setState({featuredBanner: ''})
  }

  onChange(e) {
    this.setState({
      link: e.target.value
    })
  }

  onChangeFile(e) {
    let reader = new FileReader();
    let file = e.target.files[0];
    let data = new FormData();
    data.append('fileUpload', file);
    axios({
      method: 'POST',
      url:`${this.state.API_URL}/containers/categories/upload`,
      headers: {
        Authorization: `${this.state.access_token}`
      },
      data: data
    }).then(response => {
      this.setState({
        featuredBanner: response.data.result.files['fileUpload'][0]['name']
      })
    })
  }

  saveData() {
    let data = {
      featuredBanner: this.state.featuredBanner || '',
      accompanyingInfo: {
        link: this.state.link
      }
    }
    axios({
      method: 'PATCH',
      url:`${this.state.API_URL}/categories/${this.state.item.id}`,
      headers: {
        Authorization: `${this.state.access_token}`
      },
      data: data
    }).then(response => {
      toastr.removeByType('success');
      toastr.success("Thành công", "Cập nhật thông tin thành công");
      this.setState({
        item: {},
        featuredBanner: '',
        link: '',
        modalIsOpen: false
      }, () => {
        this.getCategory()
      })
    })
  }

  render() {
    let ListCategory = this.state.categories && this.state.categories.map((item, index) => {
      return(
        <tr className='item-banner-category' key={item.id}>
          <td style={{textAlign: 'center'}}>{index + 1}</td>
          <td>{item.name}</td>
          <td>{item.featuredBanner ? (<img className='banner' alt={`Banner danh mục ${item.name}`} src={`${this.state.API_URL}/containers/categories/download/${item.featuredBanner}`}/>) : (<p>Chưa có banner</p>)}</td>
          <td>{item.accompanyingInfo && item.accompanyingInfo.link ? (<a href={item.accompanyingInfo.link} target='_blank' className='txt-link-banner'>{item.accompanyingInfo.link}</a>) : (<p>Chưa có liên kết</p>)}</td>
          <td>
            <div className='wrap-actions text-center'>
              <button className='btn btn-primary mb5' onClick={this.showPopup.bind(this, item)}>Cập nhật thông tin</button>
            </div>
          </td>
        </tr>
      )
    })
    return (
      <div>
        <table className='list-banner-category'>
          <thead>
            <tr>
              <th style={{width: 50, minWidth: 50, maxWidth: 50, textAlign: 'center'}}>STT</th>
              <th style={{width: 270, minWidth: 270 }}>Tên danh mục</th>
              <th style={{width: 270, minWidth: 270 }}>Banner danh mục</th>
              <th style={{width: 300 }} className='txt-link-banner'>Liên kết banner</th>
              <th style={{minWidth: 170 }}>Thao tác</th>
            </tr>
          </thead>
          <tbody>
            {ListCategory}
          </tbody>
        </table>
        <Modal
            isOpen={this.state.modalIsOpen}
            onRequestClose={this.closeModal.bind(this)}
            className='modal-custom modal-category'
          >
            <div className='title-block'>
              <button className='btn-close' onClick={this.closeModal.bind(this)}>×</button>
            </div>
            <div className='wrap-content-modal'>
              <h4 className='content-message text-center'>Banner danh mục</h4>
              <div className='wrap-upload'>
                <div className='input-upload'>
                  <input type='file' value='' onChange={this.onChangeFile.bind(this)} />
                  <p className="fa fa-cloud-upload" />
                  <p>Upload banner</p>
                </div>
                <div className='preview-image'>
                  {this.state.featuredBanner && (
                    <div className='wrap-image'>
                      <button className='btn-delete' onClick={this.onRemoveImage.bind(this)}>×</button>
                      <img src={`${this.state.API_URL}/containers/categories/download/${this.state.featuredBanner}`} />
                    </div>
                    )}
                </div>
              </div>
              <h4 className='content-message text-center'>Liên kết banner</h4>
              <input type='text' className='input-link' value={this.state.link} onChange={this.onChange.bind(this)} />
              <div className='wrap-btn-action'>
                <button className='btn btn-primary' disabled={this.state.loading} onClick={this.saveData.bind(this)}>Lưu</button>
              </div>
            </div>
          </Modal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/fair/BannerCategory.jsx